const MuiButtonBase = {
  disableRipple: true,
}

export const buttonBase = {
  MuiButtonBase,
}